import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { fontkoKR } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import ProgressContext from '@mirinae/lessons/modules/contexts/progress';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import MiniLessonGoButton from '@mirinae/lessons/components/buttons/MiniLessonGoButton';
import { ProgressBar } from '@mirinae/lessons/components/card/LessonCard';
import { fontDefault, lessonsPalette } from '@mirinae/lessons/modules/defines/styles';
import { irregularIcons } from '@mirinae/lessons/components/lesson/graphicComponentMap';

const CardIcon = styled.img`
    width: 70px;
    height: 70px;
    ${os.isOthers ? `
        align-self: flex-end;
        margin-top: 7px;
    ` : `
        position: absolute;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
    `}
`;

const NoIcon = styled.div`
    width: 70px;
    height: 70px;
    ${os.isOthers ? `
        align-self: flex-end;
        margin-top: 7px;
    ` : `
        position: absolute;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
    `}
`;

const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 13px 20px 20px;
    ${!os.isOthers && `
        min-height: auto;
        padding: 15px 60px 15px 105px;
        a {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
        }
    `}
`;

const SectionMissingMsg = styled.div`
    font-size: 10px;
    color: red;
    border: thin solid red;
    border-radius: 25px;
    height: 47px;
    width: 152px;
    padding: 15px 12px 6px 12px;
    text-align: center;
`;

const CardTitle = styled.div`
    font-family: ${fontkoKR};
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 30px;
    margin: 7px 0;
    color: ${lessonsPalette.grey[0]};
`;

const CardSubtitle = styled.div`
    font-family: ${fontDefault};
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 17px;
    margin-bottom: 7px;
`;
const MiniLlessonCardWrapper = styled.div`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid ${lessonsPalette.grey[5]};
    border-radius: 10px;
    background-color: ${lessonsPalette.primary.white};
    overflow: hidden;
    box-shadow: inset 6px 5px 20px rgba(244, 244, 244, 0.25), inset -6px -5px 20px rgba(186, 186, 186, 0.17);
    filter: drop-shadow(4px 2px 15px rgba(159, 188, 186, 0.2));

    ${os.isOthers ? `
        width: 192px;
        height: 250px;
        &:hover {
            box-shadow: inset -1px -1px 1px ${lessonsPalette.primary.main}, inset 1px 1px 1px rgba(148, 208, 205, 0.53), inset 6px 5px 20px rgba(244, 244, 244, 0.25), inset -6px -5px 20px rgba(186, 186, 186, 0.17);
            filter: drop-shadow(4px 2px 15px rgba(159, 188, 186, 0.5));
        }
    ` : `
        width: 100%;
        margin-bottom: 15px;
    `}
`;

export const MiniLessonCardContent = ({ element }) => {
    const player = useContext(PlayerContext);
    const sectionName = element.fieldsByName.section.value;
    const section = player.findSection(sectionName);
    const progress = useContext(ProgressContext);

    const progressValue = () => (section && progress.sections[section.nodeID] ? progress.sections[section.nodeID].progress : 0);

    return (
        <MiniLlessonCardWrapper>
            <ProgressBar progress={progressValue} />
            <CardBody>
                { irregularIcons[element.fieldsByName.icon.value] ? <CardIcon src={irregularIcons[element.fieldsByName.icon.value]} /> : <NoIcon /> }
                <CardTitle>{element.fieldsByName.title.value}</CardTitle>
                <CardSubtitle>{element.fieldsByName.subtitle.value}</CardSubtitle>
                { section
                    ? <MiniLessonGoButton section={section} size={os.isOthers && 'large'} />
                    : <SectionMissingMsg>Section &quot;{sectionName}&quot; missing</SectionMissingMsg> }
            </CardBody>
        </MiniLlessonCardWrapper>
    );
};

const MiniLessonCard = ({ element, geomElement }) => {

    return (
        <Element element={element} geomElement={geomElement}>
            <MiniLessonCardContent element={element} />
        </Element>
    );
};

export default MiniLessonCard;
